import { CommonService } from 'app/services/common.service';
import { NotificationService } from './../../services/notification.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { Component, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';




@Component({
  selector: 'app-average-net-price',
  templateUrl: './average-net-price.component.html',
  styleUrls: ['./average-net-price.component.scss']
})
export class AverageNetPriceComponent implements OnInit {

  financialAddListJson: any;
  financialFormListJson: any;
  financialTitleIVJson: any;
  chart;
  generalData: any;
  scoredata;

  constructor(
    private _commonRequestResponseService: CommonRequestResponseService ,
    private notificationService: NotificationService,
    private _commonService: CommonService
  ) { }

  ngOnInit() {
    this.getFinancialAidComponentList();
  }

  getFinancialAidComponentList() {
    this._commonService.getData().subscribe(detailData => {
        if (detailData && detailData['collegeDetailGeneralData']) {
          this.scoredata = detailData['collegeDetailGeneralData'].titleIV;
          this.financialAddListJson = detailData['collegeDetailGeneralData'].office;
          this.financialFormListJson = detailData['collegeDetailGeneralData'].forms;
          this.generalData = detailData['collegeDetailGeneralData'];

          this.financialTitleIVJson = detailData['collegeDetailGeneralData'].titleIV;
          const newArray = [], chartArray = [];

          for (let i = 0; i < Object.keys(this.financialTitleIVJson).length; i++) {
            const key = Object.keys(this.financialTitleIVJson)[i];
            const obj = {name : key , value : this.financialTitleIVJson[key] };
            newArray.push(obj);

          }
          let tempObj = {};
          for (let i = 0; i < newArray.length; i++) {
            tempObj = {name : 'series' + i , y : Math.ceil(newArray[i]['value']) , extraValue : Math.ceil(newArray[i]['value']).toString()};
            chartArray.push(tempObj);
          }

          this.chart = new Chart({
            chart: {
              type: 'column',
              height : 240,
              width : 240
            },
            title: {
              text: 'Title IV Qualifiers'
            },
            tooltip: {
              formatter: function () {
                  if (this.point.options.y) {
                    return 'Name: ' + this.point.options.name + ' <br/>' + '<br/>Score Value: ' + this.point.options.y.toString();
                  }
              }
            },
            series: [{
                data: chartArray
              }],
              plotOptions: {
                pie: {
                    size: 120,
                    cursor: 'pointer',
                    dataLabels: {
                        distance: -20,
                        formatter : function() {
                          if (this.point.options.y > 0) {
                            return this.point.options.y;
                          } else {
                            return '';
                          }
                        },
                        shadow : false
                    },
                    borderColor: '#eee',
                    borderWidth: 5
                }
              }
            });
        }
    });
  }
}
